import { NgIf } from "@angular/common";
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from "@angular/router";
import {
    KursanmeldungApiService,
    KursInfoApiService, KursInfoTeilnehmerVO,
    KursInfoVO,
    TeilnehmerApiService,
    TeilnehmerVO,
} from "@core/api/v1";
import { kursTitelMap } from "@core/model/kursTitel";
import { KeineAnmeldungComponent } from "@core/overlays/keine-anmeldung/keine-anmeldung.component";
import { KursAnmeldungComponent } from "@core/overlays/kurs-anmeldung/kurs-anmeldung.component";
import { LoginService } from "@core/services/login/login.service";
import { Button } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import PlatzKontingentEnum = KursInfoTeilnehmerVO.PlatzKontingentEnum;
import TypEnum = KursInfoVO.TypEnum;

@Component({
    selector: 'app-kurs-details',
    standalone: true,
    imports: [
        RouterLink,
        RouterLinkActive,
        NgIf,
        Button,
        DialogModule,
        KursAnmeldungComponent,
        KeineAnmeldungComponent,
    ],
    templateUrl: './kurs-details.component.html',
    styleUrl: './kurs-details.component.scss',
})
export class KursDetailsComponent implements OnInit {
    kurs: KursInfoVO = {};
    kursDatum: string;
    isAngemeldet: boolean = false;
    istAnmeldefristEingehalten: boolean;
    @ViewChild(KursAnmeldungComponent) kursanmeldungCmp: KursAnmeldungComponent;
    @ViewChild(KeineAnmeldungComponent) keineAnmeldungCmp: KeineAnmeldungComponent;
    verfuebarePlaetze: number;
    isLoggedIn: boolean;
    bereitsAngemeldet: boolean;
    teilnehmer: TeilnehmerVO;
    bestaetigungVisible: boolean = false;
    anmeldungText: string = '';

    constructor(private kursApiService: KursInfoApiService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private loginService: LoginService,
                private kursanmeldungService: KursanmeldungApiService,
                private teilnehmerService: TeilnehmerApiService) {
    }

    ngOnInit(): void {
        this.holeKurs();
    }

    holeKurs() {
        const id = Number(this.activatedRoute.snapshot.paramMap.get("id"));

        this.kursApiService.holeKursMitId(id).subscribe((response) => {
                this.kurs = response;
                this.verfuebarePlaetze = response.freiePlaetze!;

                const diff = Math.ceil(Math.abs(new Date(this.kurs.datum!).getTime() - Date.now()) / 1000 / 60 / 60 / 24);
                console.log(this.kurs.datum);
                console.log(new Date(this.kurs.datum!))
                this.istAnmeldefristEingehalten = (diff > 14);

                this.kursDatum = new Date(this.kurs.datum!).toLocaleDateString('de-AT',
                    { // Anzeigeoptionen
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    });

                this.loginService.isLoggedIn.subscribe((data) => {
                    this.isLoggedIn = data;
                });
                if (this.isLoggedIn) {
                    this.kursanmeldungService.istTeilnehmerAngemeldet(Number(this.activatedRoute.snapshot.paramMap.get("id"))).subscribe(response => {
                            this.isAngemeldet = response;
                        },
                    );

                    if (this.kurs.typ === "REZERT_PFLEGEGELD" || this.kurs.typ === "ZERT_PFLEGEGELD" || this.kurs.typ === 'REZERT_PENSION'
                        || this.kurs.typ === 'ZERT_PENSION') {
                        this.kursanmeldungService.istTeilnehmerAngemeldetImSelbenKurs(Number(this.activatedRoute.snapshot.paramMap.get("id"))).subscribe(res => {
                            this.bereitsAngemeldet = res;
                        });
                    }

                    this.teilnehmerService.holeTeilnehmer().subscribe(res => {
                        this.teilnehmer = res;

                        if (res.beruf !== 'ARZT') {
                            // Check ob Kurs nur fuer Aerzte ist
                            if (this.kurs.typ === 'ZERT_PENSION' || this.kurs.typ === 'REZERT_PENSION' || this.kurs.typ === 'REZERT_PENSION_PSYCHIATRIE') {
                                this.anmeldungText = 'Anmeldung nur für ÄrztInnen';
                            }
                            // Check ob Kurs nur fuer Psychologen ist
                            else if (res.beruf === 'PFLEGER' && this.kurs.typ === 'ZERT_GUTACHTUNG_AUVA') {
                                this.anmeldungText = 'Anmeldung nur für ÄrztInnen & PsychologInnen';
                            }
                            // Check ob Kurs nur fuer Pfleger ist
                            else if (res.beruf === 'PSYCHOLOGE' && (this.kurs.typ === 'ZERT_PFLEGEGELD' || this.kurs.typ === 'REZERT_PFLEGEGELD' || this.kurs.typ === 'ZERT_PFLEGEGELD_KINDER')){
                                this.anmeldungText = 'Anmeldung nur für ÄrztInnen & PflegerInnen';
                            }
                        }
                    });
                }
        }, error => {
            this.router.navigate(["seite"]);
        });
    }

    zeigeOverlay() {
        if (!this.bereitsAngemeldet) {
            this.kursanmeldungCmp.openOverlay(this.kurs, this.teilnehmer);
        } else {
            this.keineAnmeldungCmp.openOverlay();
        }
    }

    hideAnmeldenBtn(kurs: KursInfoVO) {
        this.isAngemeldet = true;
        this.verfuebarePlaetze = kurs.freiePlaetze!;
        this.bestaetigungVisible = true;
    }

    protected readonly Boolean = Boolean;


    titel(typ: TypEnum) {
        return kursTitelMap[typ];
    }
}
